<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <c-table
        ref="vendorUserTable"
        title="도급업체 근무인원"
        tableId="vendorUserTable"
        :columns="grid.columns"
        :data="grid.data"
        :usePaging="false"
        :hideBottom="true"
        :columnSetting="false"
        selection="multiple"
        rowKey="vendorUserCd"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable && this.parentVendorCd" label="추가" icon="add" @btnClicked="addrow" />
            <c-btn v-if="editable && this.parentVendorCd" label="저장" icon="save" @btnClicked="saveVendorUser" />
            <c-btn v-if="editable && this.parentVendorCd" label="삭제" icon="remove" @btnClicked="removerow" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'vendor-user',
  props: {
    parentVendorCd: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedVendorCd: '',
      grid: {
        columns: [],
        data: [],
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  watch: {
    parentVendorCd() {
      if (this.parentVendorCd) {
        this.getVendorUserList({ vendorCd: this.parentVendorCd })
      }
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.cim.vendor.user.list.url;
      this.saveUrl = transactionConfig.mdm.cim.vendor.user.save.url;
      this.deleteUrl = transactionConfig.mdm.cim.vendor.user.delete.url;

      this.$comm.getComboItems('SEX_CD').then(sexFlag => {
        this.grid.columns = [
          {
            name: 'personName',
            field: 'personName',
            label: '성명',
            align: 'center',
            sortable: false,
            style: 'width:120px',
            type: 'text',
          },
          {
            name: 'birthDate',
            field: 'birthDate',
            label: '생년월일',
            style: 'width:130px',
            type: 'date',
            align: 'center',
            sortable: false,
          },
          {
            name: 'sexCd',
            field: 'sexCd',
            label: '성별',
            align: 'center',
            style: 'width:80px',
            sortable: false,
            valueName: 'codeName',
            itemText: 'codeName',
            itemValue: 'code',
            type: 'select',
            comboItems: sexFlag,
          },
          {
            name: 'jobName',
            field: 'jobName',
            label: '직책',
            style: 'width:100px',
            type: 'text',
            align: 'center',
            sortable: false,
          },
          {
            name: 'remarks',
            field: 'remarks',
            label: '비고',
            align: 'left',
            type: 'text',
            sortable: false,
          },
        ];
        if (this.parentVendorCd) {
          this.getVendorUserList({ vendorCd: this.parentVendorCd })
        }
      });
    },
    getVendorUserList(row) {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {vendorCd: row.vendorCd};
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    addrow() {
      // 초기에는 userId에 tempId를 부여
      this.grid.data.splice(0, 0, {
        editFlag: 'C',
        vendorCd: this.parentVendorCd,
        vendorUserCd: '',
        personName: '',
        birthDate: '',
        sexCd: null,
        jobName: '',
        remarks: '',
      })
    },
    saveVendorUser() {
      let checkItem = ['personName', 'sexCd']
      let isConti = true;
      this.$_.forEach(this.grid.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [성명, 성별]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let saveData = this.grid.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = this.saveUrl;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                window.getApp.$emit('ALERT', {
                  title: '안내 ', /* 안내 */
                  message: '저장되었습니다.', /* 저장되었습니다. */
                  type: 'success', // success / info / warning / error
                });
                this.getVendorUserList({ vendorCd: this.parentVendorCd })
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    removerow() {
      let selectData = this.$refs['vendorUserTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.deleteUrl);
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              this.getVendorUserList({ vendorCd: this.parentVendorCd })
              window.getApp.$emit('ALERT', {
                title: '안내 ', /* 안내 */
                message: '삭제되었습니다.', /* 삭제되었습니다. */
                type: 'success', // success / info / warning / error
              });
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>
